import { Locales } from '@monoimin/sb-types';

export const getPathnameWithoutPrefix = (
  pathname: string | null,
  locale: Locales
) => {
  if (!pathname) {
    return '';
  }

  if (pathname.startsWith(`/${locale}/`)) {
    return String(pathname).replace(`/${locale}/`, '/');
  }

  return pathname;
};

export default getPathnameWithoutPrefix;
